var indentation_default = {
  "indentZero": "K2GSF",
  "indentOne": "_5A9N2",
  "indentTwo": "C2-fx",
  "indentThree": "pzgpl",
  "indentFour": "_4I1b-",
  "indentFive": "eTiH3",
  "indentSix": "kXrIK"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
